import { produce } from "immer";
import React, { useMemo } from "react";

import { languageList, languageMeta } from "@examspark/common/dist/meta/assets";
import { Text } from "@examspark/common-ui";
import { useDebounce } from "@examspark/common-ui/dist/hooks/useDebounce";
import { Language } from "@examspark/types";

import { Filter, FilterData } from "../Browse";
import {
  getTermAggregationBucketValue,
  useSearch,
  useSearchFn,
} from "../useSearch";

import FilterCheckboxList from "./FilterCheckboxList";

const FilterLanguage = (props: {
  onChange: (values: string[]) => void;
  useSearchFn?: useSearchFn;
  filters: FilterData;
}) => {
  const filter = useMemo(() => {
    const { languages, ...filter } = props.filters;
    return filter;
  }, [props.filters]);

  const debouncedFilter = useDebounce(filter, 500);

  const searchFn = props.useSearchFn ?? useSearch;

  const { data } = searchFn({
    queryKey: ["aggs", "type", debouncedFilter],
    searchLabel: "SearchAggsType",
    limit: 0,
    filter: debouncedFilter,
  });

  return (
    <Filter>
      <Text.H2>Language</Text.H2>
      <FilterCheckboxList>
        {languageList.map((langauge) => {
          /* hardcoding for now */
          if (![Language.English, Language.Spanish].includes(langauge)) {
            return null;
          }

          const count =
            data?.aggregations &&
            getTermAggregationBucketValue(
              data?.aggregations,
              "languages",
              langauge,
            );

          return (
            <FilterCheckboxList.Item
              key={langauge}
              count={count ?? 0}
              onClick={() => {
                props.onChange(
                  produce(props.filters.languages ?? [], (draft) => {
                    if (draft.includes(langauge)) {
                      draft.splice(draft.indexOf(langauge), 1);
                    } else {
                      draft.push(langauge);
                    }
                  }),
                );
              }}
              checked={props.filters.languages?.includes(langauge)}
            >
              {languageMeta[langauge].label}
            </FilterCheckboxList.Item>
          );
        })}
      </FilterCheckboxList>
    </Filter>
  );
};

export default FilterLanguage;
